import { EuiSpacer } from '@elastic/eui';
import VideoCard01 from 'components/Quick_Installation/Videos/video-hd-45-webui-firmware-update';
import VideoCard02 from 'components/Quick_Installation/Videos/video-hd-56-webui-firmware-update';
import * as React from 'react';
export default {
  EuiSpacer,
  VideoCard01,
  VideoCard02,
  React
};